<template>
<div class="chapter">
<div class="inner_page">
<h1 title="A Split Worlds Omnibus (BOOKS 1–3)">A Split Worlds Omnibus<br/><span class="small">BOOKS 1–3</span></h1>
<h3 class="sigil_not_in_toc"><a href="#/Text/1_BTT_TITLEPAGE"><i>Between Two Thorns</i></a></h3>
<h3 class="sigil_not_in_toc"><i><span href="#/Text/2_AON_TITLEPAGE" title="Link target outside of Sample">Any Other Name</span></i></h3>
<h3 class="sigil_not_in_toc"><span href="#/Text/3_AIF_TITLEPAGE" title="Link target outside of Sample"><i>All is Fair</i></span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM1_TitlePage.vue?748ffc54